import React from "react";
import angel2 from "../../assets/leftangel.png";
import angel1 from "../../assets/rightangel.png";
import "./about.css";

const About = () => {
  return (
    <section className="about">
      <div className="container">
        <div className="angel-left">
          <img src={angel2} alt="Left angel" />
        </div>

        <div className="angel-right">
          <img src={angel1} alt="Right angel" />
        </div>

        <div className="about-content">
          <h1 className="about-title">About</h1>

          <p className="about-text">
          DanteGPU democratizes access to high-performance computing by enabling
          individuals and organizations to monetize their unused GPU resources.
          Through a blockchain-powered marketplace, AI developers and researchers
          can directly access these distributed resources, ensuring efficient and
          equitable computing power utilization.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
